import * as yup from 'yup';

const LoginVS = yup.object().shape({
    email: yup.string().email('Invalid Email').required('Email is Required').label('email'),
    password: yup.string().required('Password is Required').label('password')
});
const ForgotVS = yup.object().shape({
    email: yup.string().email('Invalid Email').required('Email is Required').label('email')
});
const FieldVS = yup.object().shape({
    field: yup.string().required('Field is Required').label('field')
});
const WareHouse = yup.object().shape({
    name: yup.string().required('WareHouse is Required').label('field')
});
const CategoryVS = yup.object().shape({
    name: yup.string().required('Category is Required').label('name'),
});
const InventoryVS = yup.object().shape({
    quantity: yup.string().required('Quantity is Required').label('quantity')
});
const SubCategoryVS = yup.object().shape({
    category: yup.mixed().required('Category is Required').label('category'),
    subname: yup.string().required('Sub Category is Required').label('subname'),
    point: yup.string().required('Point is Required').label('point'),

});
const ModelVS = yup.object().shape({
    model: yup.string().required('Model is Required').label('model'),
    brand: yup.mixed().required('Brand is Required').label('brand')
});
const PoVS = yup.object().shape({
    model: yup.mixed().required('Model is Required').label('model'),
    brand: yup.mixed().required('Brand is Required').label('brand'),
    competebleBrand: yup.mixed().required('competeble Brand is Required').label('competebleBrand'),
    ProductCategory: yup.mixed().required('ProductCategory is Required').label('ProductCategory'),
    color: yup.mixed().required('color is Required').label('color'),
    SubCategory: yup.mixed().required('SubCategory is Required').label('SubCategory'),
    price: yup.string().required('price is Required').label('price'),
    // supplier: yup.mixed().required("supplier is Required").label("supplier"),
    quantity: yup.string().required('quantity is Required').label('quantity'),
    description: yup.mixed().label('description')
});
const OtpVS = yup.object().shape({
    otp: yup.string().required('Otp is Required').label('otp')
});
const resetPasswordVS = yup.object().shape({
    password: yup.string().required('password is Required').label('password'),
    confirmPassword: yup
        .string()
        .required('Confirm Password is Required')
        .oneOf([yup.ref('password'), null], 'Passwords must match')
});

const SignUpVS = yup.object().shape({
    username: yup.string().required('Username is Required').label('username'),
    email: yup.string().required('Email is Required').email('Invalid Email').label('email'),
    firstname: yup.string().required('Firstname is Required').label('firstname'),
    lastname: yup.string().required('Lastname is Required').label('lastname'),
    phonenumber: yup.string().required('Phone Number is Required').label('phonenumber'),
    password: yup.string().required('Password is Required'),
    confirmPassword: yup
        .string()
        .required('Confirm Password is Required')
        .oneOf([yup.ref('password'), null], 'Passwords must match'),
    dob: yup.string().required('Date of Birth is Required').label('dob'),
    gender: yup.string().required('Gender is Required').label('gender')
});
const SupplierVS = yup.object().shape({
    supplier: yup.string().required('Supplier is Required').label('supplier'),
    address: yup.string().required('Address is Required').label('address'),
    phone: yup.number().required('Phone is Required').label('phone'),
    refFeild: yup.string().label('refFeild'),
    whareHouse: yup.mixed().label('whareHouse'),
});
const AddUserVS = yup.object().shape({
    username: yup.string().required('Username is Required').label('username'),
    email: yup.string().required('Email is Required').email('Invalid Email').label('email'),
    password: yup.string().required('Password is Required'),
    authorize: yup.mixed().required('Role is Required')
});
const EditUserVS = yup.object().shape({
    username: yup.string().required('Username is Required').label('username'),
    email: yup.string().required('Email is Required').email('Invalid Email').label('email'),
    password: yup.string().nullable().notRequired().label('password'),
    authorize: yup.mixed().required('Role is Required')
});
const EditProfileVS = yup.object().shape({
    name: yup.string().required('Name is Required').label('name'),
    email: yup.string().required('Email is Required').email('Invalid Email').label('email'),
    password: yup.string().nullable().notRequired().label('password')
});
const InternalTransferVS = yup.object().shape({
    personName: yup.string().required('Person Name is Required').label('personName'),
    refNumber: yup.string().label('refNumber'),
});

const MatchProductVS = yup.object().shape({
    product_name: yup.string().required('Product Name is Required').label('product_name'),
    group: yup.string().required('Group is Required').label('group'),
    height: yup.string().required('Height is Required').label('height'),
    width: yup.string().required('Width is Required').label('width'),
});

export { LoginVS, SignUpVS, ForgotVS, OtpVS, resetPasswordVS, FieldVS, WareHouse, CategoryVS, SubCategoryVS, ModelVS, PoVS, SupplierVS, AddUserVS, EditUserVS, EditProfileVS, InventoryVS, InternalTransferVS, MatchProductVS };
